export const landingContent = {
  nav: [
    { href: "#system", label: "Система" },
    { href: "#value", label: "Ценность" },
    { href: "#proof", label: "Отзывы" },
    { href: "#pricing", label: "Тарифы" },
    { href: "#faq", label: "FAQ" },
  ],
  hero: {
    badge: "APEX USMLE PRO",
    title:
      "Сдай USMLE Step 1 с первой попытки — полная система подготовки на русском языке",
    description:
      "Для врачей и студентов, которые хотят учиться на своём языке и не готовы платить 400K\u20BD за разрозненные курсы. От доктора, который набрал 260 и match-нулся в Maryland.",
    primaryCta: "Начать подготовку",
    primaryHint: "Только 990\u20BD на пробу",
    secondaryCta: "Посмотреть, что входит",
    stats: [
      "239 Step 1",
      "260 Step 2 CK",
      "9,200+ в Telegram",
      "45,000\u20BD за год",
    ],
    trustPoints: [
      "7 компонентов в одной системе",
      "Учёба на русском, экзамен без хаоса",
      "Оплата пока не подключена: CTA ведут к тарифам",
    ],
  },
  pain: {
    eyebrow: "Узнай себя?",
    title: "Проблема не в мотивации. Проблема в отсутствии системы.",
    items: [
      {
        title: "Ты знаешь медицину. Но не знаешь USMLE.",
        text: "Российская медшкола учит одному. Step 1 спрашивает другое. Ты можешь знать патофизиологию наизусть - и провалиться, потому что не понял, как думать в формате клинических задач.",
      },
      {
        title: "Непонятно, с чего начинать",
        text: "230 тем, тысячи вопросов, и ни одного внятного порядка. Половина времени уходит не на учебу, а на поиск: какой ресурс выбрать, с чего начать, что вообще high-yield. Пока ты разбираешься в структуре - другие уже на третьей неделе системной подготовки.",
      },
      {
        title: "Подготовка стоит как ещё одна зарплата",
        text: "UWorld, Amboss, репетиторы и отдельные курсы складываются в 100K\u2013150K\u20BD и выше.",
      },
      {
        title: "Ресурсы не связаны между собой",
        text: "Видео отдельно, карточки отдельно, вопросы отдельно. Вместо системы ты покупаешь набор вкладок.",
      },
      {
        title: "Тревога без ориентира",
        text: "Нет внешней оценки, нет ориентира. Ты можешь учиться по 8 часов в день и при этом не понимать, движешься ли ты к 240 или к 200. Эта неопределенность изматывает сильнее самой учебы.",
      },
      {
        title: "Ты остаёшься один",
        text: "Когда начинаются сомнения, рядом нет ни плана, ни комьюнити, ни человека, который уже прошёл этот путь.",
      },
    ],
  },
  agitation: {
    title: "Если ничего не менять, цена ошибки становится слишком большой.",
    description:
      "Шесть месяцев хаотичной подготовки - это не просто потерянное время. Это перенесенный экзамен, закрытые окна в программы и ощущение, что ты двигался, но не туда.",
    outcomes: [
      "Пробники застревают на пороговых значениях. Нет уверенности, усталость от вечной учебы, выгорание.",
      "Деньги уходят в UWorld, Amboss, курсы с лекциями по 3 часа от студентов - каждый по отдельности. Системы нет, прогресса не видно.",
      "Пока ты разбираешься в ресурсах, другие уже сдали. Окно в хорошую программу не ждет.",
    ],
    note: "APEX нужен именно для того, чтобы убрать этот сценарий заранее.",
  },
  solution: {
    title: "Встречай APEX System",
    description:
      "Это не просто видеокурс. Это полная система подготовки, которую я строил год - чтобы у тебя был правильный старт с первого дня.",
    pillars: [
      "Один маршрут вместо десятка разрозненных сервисов. Видео, тесты, карточки, план и поддержка - всё в одном месте. Не нужно собирать подготовку из кусков самому.",
      "Видеолекции на русском и английском. PDF, Anki, тесты и библиотека из 1200 концептов на английском. Терминологию учишь внутри контекста экзамена, а не отрывочными переводами.",
      "Четкий пошаговый план на каждый день для каждого раздела - что читать, что смотреть, что решать и в каком порядке.",
      "Закрытый чат с преподавателями и студентами, которые ответят на ваши вопросы и поддержат.",
    ],
  },
  components: [
    {
      title: "APEX Video Lectures",
      subtitle: "",
      oldPrice: "120,000\u20BD",
      description:
        "Большинство IMGs тратят месяцы на материалы которые не объясняют почему. Здесь весь Step 1 с клинической логикой на русском, от врача который сам сдал на 239.",
    },
    {
      title: "PDF Slides",
      subtitle: "",
      oldPrice: "40,000\u20BD",
      description:
        "Лекция посмотрена и хочется быстро повторить? PDF-конспект это якорь. Компактно, структурированно, всё главное на одной странице.",
    },
    {
      title: "Anki Decks",
      subtitle: "",
      oldPrice: "15,000\u20BD",
      description:
        "Без повторения знания исчезают за 48 часов. Карточки появляются точно тогда, когда мозг готов закрепить материал навсегда.",
    },
    {
      title: "FANKI",
      subtitle: "12,500 оригинальных карточек",
      oldPrice: "30,000\u20BD",
      description:
        "Оригинальная колода по всем темам из First Aid, которая позволит запомнить и понять материал именно так, как его спрашивает экзамен. Плотность знаний за минимальное время.",
    },
    {
      title: "APEX QBank",
      subtitle: "",
      oldPrice: "100,000\u20BD",
      description:
        "UWorld бросает новичка в глубину с первого вопроса. APEX QBank строит клиническое мышление постепенно - 5,000+ вопросов которые готовят к UWorld, а не топят в нём. Каждый ответ с развёрнутым объяснением на русском и английском.",
    },
    {
      title: "Study Plan + Закрытый чат",
      subtitle: "",
      oldPrice: "75,000\u20BD",
      description:
        "Самая частая причина провала - не незнание материала, а отсутствие плана действий. Чёткий маршрут с контрольными точками и закрытый чат с преподавателями и менторами убирают это полностью.",
    },
  ],
  valueStack: {
    title: "Всё включено",
    description: ["Единая готовая система.", "Всё для Step\u00a01 уже внутри."],
    items: [
      { text: "100+ видеолекций", note: "по всем дисциплинам" },
      { text: "PDF-презентации", note: "к каждой лекции" },
      { text: "12,500 Anki-карточек", note: "FANKI" },
      { text: "5,000+ вопросов", note: "мини-тесты EN + RU" },
      { text: "Клинические задачи", note: "формат USMLE" },
      { text: "Study Plan", note: "пошаговый план" },
      { text: "1,200+ модулей", note: "First Aid" },
      { text: "Аналитика", note: "прогресс и статистика" },
      { text: "Telegram-чат", note: "поддержка и комьюнити" },
    ],
    oldPrice: "365,000\u20BD",
    price: "от 6,500\u20BD",
    cta: "Узнать подробнее",
  },
  about: {
    title: "Ашуров Мухаммад",
    story: [
      "Я прошёл тот же путь что и вы \u2013 хаос ресурсов, бессмысленные траты и ощущение, что учишься не туда. Русскоязычный IMG, без американского диплома, без готовой системы. Подготовка к USMLE помогла мне окончить Сеченовский Университет с красным дипломом.",
      "Всё что я узнал, каждую ошибку и каждый инсайт \u2013 я вложил в APEX. Название не случайное \u2013 вершина. Каждый компонент строился с огромным вниманием к деталям \u2013 чтобы у вас было всё необходимое для пути к своей вершине. Чтобы русскоязычный студент не терял месяцы на входе.",
      "Потому что каждый, кто заходит в APEX \u2013 заслуживает до неё дойти.",
      "APEX \u2013 к вершинам вместе.",
    ],
    metrics: [
      { label: "Step 1", value: "239" },
      { label: "Step 2 CK", value: "260" },
      { label: "ECFMG", value: "Certified" },
      { label: "Match", value: "IM" },
    ],
  },
  testimonials: [
    {
      name: "Студент APEX",
      role: "Врач из крупного города",
      quote:
        "Я потратил 3 месяца на хаотичную подготовку, потом нашёл APEX. После второго месяца с системой всё наконец-то сложилось в одну картину. Step 1 \u2014 247.",
    },
    {
      name: "Студент 6 курса",
      role: "Будущий IMG",
      quote:
        "До этого я не мог выбраться из UWorld на английском. APEX дал структуру и уверенность. Видеолекции настолько понятные, что я рекомендую их друзьям. Step 1 \u2014 239.",
    },
    {
      name: "IMG из СНГ",
      role: "Готовился параллельно с работой",
      quote:
        "Я не мог позволить себе дорогого репетитора. APEX дал больше, чем консультации по кускам, потому что это повторяемая система. Результат \u2014 251.",
    },
  ],
  guarantee: {
    title: "Pass or Refund",
    intro:
      "Прошёл программу честно и не сдал - возвращаю деньги.",
    conditions: [
      "Завершены 100% лекций и заданий",
      "Пройдено 70%+ QBank",
      "Пройдены все Anki/FANKI карточки",
      "Экзамен сдан в течение 1.5 месяцев после окончания программы",
      "Первая попытка после прохождения системы",
      "Score report + запрос на возврат в течение 30 дней",
    ],
    outro:
      "Не сдал - возврат 100%.",
  },
  pricing: {
    title: "Выбери свой темп",
    plans: [
      {
        name: "1 месяц",
        oldPrice: "9,000\u20BD",
        price: "4,900\u20BD",
        perMonth: "4,900\u20BD/мес",
        description: "Войти в систему, оценить глубину материала и понять - это то, что нужно.",
        cta: "Скоро",
      },
      {
        name: "3 месяца",
        oldPrice: "19,500\u20BD",
        price: "12,900\u20BD",
        perMonth: "4,300\u20BD/мес",
        description: "Пройти 40-50% программы, закрыть слабые темы и увидеть рост в тестах.",
        cta: "Скоро",
      },
      {
        name: "6 месяцев",
        oldPrice: "39,000\u20BD",
        price: "23,900\u20BD",
        perMonth: "3,983\u20BD/мес",
        description: "Пройти всю программу в комфортном темпе с повторениями и без перегрева.",
        cta: "Скоро",
      },
      {
        name: "12 месяцев",
        oldPrice: "49,900\u20BD",
        price: "24,900\u20BD",
        perMonth: "2,075\u20BD/мес",
        description: "Полный цикл подготовки. Два прохода по материалу, возврат к сложным темам, уверенность на экзамене.",
        cta: "Скоро",
        featured: true,
        badge: "Лучшая цена",
        saving: "-50%",
      },
    ],
    earlyBird: {
      label: "Early Bird",
      text: "Подписчикам закрытого Telegram-класса: 49,900\u20BD \u2192 24,900\u20BD + заморозка подписки на 30 дней.",
    },
    trial: "5 дней бесплатно. Без карты. Просто зарегистрируйтесь.",
  },
  faq: [
    {
      question: "Я студент первого курса - мне подойдёт?",
      answer:
        "Да, подойдёт. Особенно если хочешь с первого курса строить фундамент и получить знания мирового уровня. Чем раньше начнёшь, тем увереннее будешь к моменту экзамена.",
    },
    {
      question: "Чем APEX отличается от UWorld?",
      answer:
        "UWorld полезен когда уже есть база и понимание материала. У русскоговорящих IMG зачастую этой базы нет. APEX - идеальный старт: система выстраивает фундамент с нуля. После APEX переход на UWorld будет осмысленным и эффективным.",
    },
    {
      question: "На каком языке обучение?",
      answer:
        "Видеолекции на русском, слайды к ним на английском. Anki-карточки на английском. Мини-тесты, клинические задачи и библиотека на платформе - английский и русский, переключается одним кликом.",
    },
    {
      question: "Как работает гарантия Pass or Refund?",
      answer:
        "Если вы прошли программу честно и не сдали - возвращаем деньги. Условия: завершены 100% лекций и заданий, пройдено 70%+ QBank, пройдены все Anki/FANKI карточки, экзамен сдан в течение 1.5 месяцев после окончания программы, первая попытка, score report + запрос на возврат в течение 30 дней.",
    },
    {
      question: "Есть ли рассрочка?",
      answer:
        "Да, рассрочка будет доступна. Следите за обновлениями на сайте и в Telegram-канале.",
    },
    {
      question: "Что такое FANKI и зачем мне 12,500 карточек?",
      answer:
        "FANKI - это концентрат High Yield материала по First Aid. 12,500 оригинальных карточек, созданных специально для запоминания ключевых фактов и связей. Идеально работает с интервальным повторением.",
    },
    {
      question: "Можно ли заниматься параллельно с учёбой в универе?",
      answer:
        "Не можно, а нужно. Подготовка к USMLE идёт параллельно с основной учёбой. Вы сами регулируете темп и нагрузку - Study Plan показывает что делать, а сколько времени в день тратить решаете вы.",
    },
    {
      question: "Как быстро откроется доступ после оплаты?",
      answer:
        "Сразу. После оплаты вы получаете полный доступ к платформе, лекциям, карточкам и Study Plan. Все инструкции будут на платформе.",
    },
    {
      question: "Есть ли бесплатный пробный период?",
      answer:
        "Да, 5 дней бесплатно. Без привязки карты. Просто зарегистрируйтесь и начните.",
    },
  ],
  comparison: {
    title: "APEX - стартовая система подготовки для IMG",
    description: "Что действительно важно при подготовке к Step 1.",
    columns: ["APEX", "UWorld", "AMBOSS", "Другие курсы"],
    apexType: "Обучающая платформа для подготовки к USMLE Step 1",
    otherTypes: ["Банк вопросов", "Банк вопросов + мед. библиотека", "Курсы лекций"],
    rows: [
      { feature: "Подготовка на русском языке", apex: true, uworld: false, amboss: false, unis: true },
      { feature: "5,500+ тестовых вопросов", apex: true, uworld: true, amboss: true, unis: false },
      { feature: "2,800+ клинических задач", apex: true, uworld: true, amboss: true, unis: false },
      { feature: "Готовый пошаговый план на каждый день", apex: true, uworld: false, amboss: null, unis: false },
      { feature: "Глубокие объяснения патофизиологии", apex: true, uworld: true, amboss: true, unis: false },
      { feature: "Библиотека на ENG + RUS", apex: true, uworld: false, amboss: true, unis: false },
      { feature: "Видеолекции", apex: true, uworld: false, amboss: false, unis: "3-часовые лекции" },
      { feature: "Качественные презентации", apex: true, uworld: false, amboss: false, unis: "Скриншоты книг" },
      { feature: "Авторы с опытом Match", apex: true, uworld: null, amboss: null, unis: "Нет опыта резидентуры" },
      { feature: "Полноценный банк вопросов", apex: true, uworld: true, amboss: true, unis: "Пиратские PDF" },
      { feature: "Отслеживание прогресса подготовки", apex: true, uworld: true, amboss: true, unis: false },
      { feature: "Поддержка студентов", apex: true, uworld: false, amboss: false, unis: null },
    ],
  },
  finalCta: {
    title: "Всё уже готово. Осталось начать.",
    description:
      "120+ видеолекций, 5,500+ тестов, 2,800+ клинических задач, 12,500 Anki-карточек и пошаговый план. Одна система вместо десяти вкладок.",
    primaryCta: "Начать за 990\u20BD",
    secondaryCta: "Посмотреть тарифы",
    disclaimer:
      "Никаких скрытых платежей. Оплату и внешние ссылки подключим следующим шагом.",
  },
};
